export const strates = `
brightStrates {
  ... on brightStrates_highlighted_BlockType {
    id
    subTitle
    titre
    description
    deliverablesTitle
    deliverablesContent
    titleRight
    typeHandle
  }
  ... on brightStrates_hooktext_BlockType {
    id
    description
    titre
    backgroundColored
    typeHandle
  }
  ... on brightStrates_hooknumber_BlockType {
    id
    numbers {
      percent
      title
      indicatif
    }
    typeHandle
  }
  ... on brightStrates_feature_BlockType {
    id
    titre
    description
    cta {
      label: col1
      href: col2
    }
    media {
      id
      url
      extension
    }
    mediaPosition
    isMediaAutoPlay
    typeHandle
  }
  ... on brightStrates_listitems_BlockType {
    id
    items {
      description
      title
    }
    typeHandle
  }
  ... on brightStrates_listlogos_BlockType {
    id
    titre
    urls {
      url
    }
    logos {
      id
      url
    }
    typeHandle
  }
  ... on brightStrates_media_BlockType {
    id
    media {
      id
      url
      extension
    }
    mediaPosition
    mediaPreview {
      id
      url
    }
    isMediaAutoPlay
    text
    textPosition
    isTextOver
    backgroundColored
    youtubeVideoId
    vimeoVideoId
    typeHandle
  }
  ... on brightStrates_cta_BlockType {
    id
    titre
    ctaPosition
    href
    typeHandle
  }
  ... on brightStrates_testimonials_BlockType {
    id
    typeHandle
  }
  ... on brightStrates_testimonialCustom_BlockType {
    id
    fullName
    role
    picture {
      id
      url
    }
    text
    typeHandle
  }
  ... on brightStrates_audio_BlockType {
    id
    titre
    song {
      url
    }
    typeHandle
  }
  ... on brightStrates_form_BlockType {
    id
    region
    portalId
    formId
    typeHandle
  }
  ... on brightStrates_sliderRelatives_BlockType {
    id
    titre
    caseStudy {
      id
      ... on brightCaseStudy_brightCaseStudy_Entry {
        id
        slug
        title
        description
        typeHandle
        brightPreview {
          id
          url
        }
      }
      typeHandle
    }
    typeHandle
  }
  ... on brightStrates_imageText_BlockType {
    typeHandle
    id
    titre
    text
    direction
    links {
      href
      col1
    }
    image {
      id
      url
    }
  }
  ... on brightStrates_doubleImageLabel_BlockType {
    id
    typeHandle
    image1 {
      id
      url
    }
    label1
    image2 {
      id
      url
    }
    label2
  }
  ... on brightStrates_triptych_BlockType {
    id
    typeHandle
    titre1
    text1
    image1 {
      id
      extension
      url
    }
    titre2
    text2
    image2 {
      id
      extension
      url
    }
    titre3
    text3
    image3 {
      id
      extension
      url
    }
  }
  ... on brightStrates_quote_BlockType {
    id
    typeHandle
    quote
    author
    job
    backgroundColored
  }
  ... on brightStrates_contact_BlockType {
    id
    typeHandle
  }
  ... on brightStrates_socialMedia_BlockType {
    id
    typeHandle
  }
  ... on brightStrates_slider_BlockType {
    id
    typeHandle
    titre
    image {
      id
      url
    }
    legends {
      legend
    }
  }
  ... on brightStrates_bigTitle_BlockType {
    id
    typeHandle
    titre
    textPosition
  }
  ... on brightStrates_embedContent_BlockType {
    id
    typeHandle
    urlLink
  }
}`
